module.exports = __webpack_public_path__ + "static/media/confirmed_inactive.9bdb7092.svg";